import React from 'react'
import ReactDOM from 'react-dom'
import '../node_modules/bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.bundle.min'
import 'bootstrap-icons/font/bootstrap-icons.css'
import 'font-awesome/css/font-awesome.css'

import App from './App'

ReactDOM.render(<App />, document.getElementById('root'))
